export let TIME_HOURS:number = 1000*60*60;

export let TIME_DAYS:number = 1000*60*60*24;

export let TIME_WEEKS:number = 1000*60*60*24*7;

export let TIME_MONTHS:number = 1000*60*60*24*30;

export let TIME_YEARS:number = 1000*60*60*24*365;



// WEBPACK FOOTER //
// ./src/constants/times.ts